import { injectIntl } from 'react-intl';
import compose from 'lodash.flowright';
import { xingConnect } from '@xingternal/frame-data-provider';
import { UpsellButton as UpsellButtonComponent } from './UpsellButton';
import { upsellButtonSelector } from './UpsellButton.selectors';
const UpsellButton = compose(xingConnect(upsellButtonSelector), injectIntl)(UpsellButtonComponent);
export { UpsellButton };
//# sourceMappingURL=UpsellButton.container.js.map